import MicroModal from 'micromodal';
import { lenis } from './Scroll';

// ============================================
// ヘッダー追従
// ============================================

function fixedHeader() {
  const header = document.querySelector('.js-header');
  const hero = document.querySelector('.js-hero');
  if (hero) {
    let headerH = header.clientHeight;
    let heroH = hero.clientHeight;
    window.addEventListener('scroll', () => {
      let scrollH = window.scrollY;
      if (scrollH > heroH) {
        header.classList.add('is-active');
      } else {
        header.classList.remove('is-active');
        if (scrollH > headerH) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      }
    });
  }
}

// ============================================
// drawer ハンバーガー開閉処理
// ============================================
function drawer() {
  MicroModal.init();

  //mediaqueryでハンバーガー実装
  const hamburger = document.querySelector('.js-drawer-hamburger');
  const navigation = document.querySelector('.js-drawer-navigation');
  const txt = document.querySelector('.js-drawer-hamburger__txt');
  if (!hamburger || !navigation) {
    return;
  }

  const menuWrap = navigation.querySelector('.l-drawer__nav');
  const menu = navigation.querySelector('.l-drawer__list');
  const wideHamburger = getComputedStyle(document.documentElement).getPropertyValue('--wide-hamburger');
  const hamburgerBreakPoint = getComputedStyle(document.documentElement).getPropertyValue('--hamburger-breakpoint');
  const mediaQuery = window.matchMedia(`(max-width: ${hamburgerBreakPoint})`);

  if (!menu || !menuWrap) return;

  const stopProp = (e) => e.stopPropagation();
  const passiveOpts = { passive: true };
  let bound = false;

  const bindMenuWrap = () => {
    if (bound) return;
    menuWrap.addEventListener('wheel', stopProp, passiveOpts);
    menuWrap.addEventListener('touchmove', stopProp, passiveOpts);
    bound = true;
  };
  const unbindMenuWrap = () => {
    if (!bound) return;
    menuWrap.removeEventListener('wheel', stopProp, passiveOpts);
    menuWrap.removeEventListener('touchmove', stopProp, passiveOpts);
    bound = false;
  };

  if (wideHamburger === 'false') {
    switchMenu(mediaQuery);
    mediaQuery.addEventListener('change', switchMenu);

    function switchMenu(mq) {
      if (mq.matches) {
        hamburger.addEventListener('click', hamburgerClick);
        bindMenuWrap();
        navigation.setAttribute('aria-hidden', true);
      } else {
        navigation.querySelectorAll('a, button').forEach((el) => {
          el.blur();
        });
        navigation.setAttribute('aria-hidden', true);
        lenis.start();
        if (hamburger.classList.contains('is-open')) {
          hamburger.classList.remove('is-open');
          hamburger.ariaExpanded = 'false';
        }
        unbindMenuWrap();
        hamburger.removeEventListener('click', hamburgerClick);
      }
    }
  } else {
    hamburger.addEventListener('click', hamburgerClick);
    if (wideHamburger === 'true') {
      bindMenuWrap();
    }
    navigation.setAttribute('aria-hidden', true);
  }

  //ハンバーガークリック関数
  function hamburgerClick() {
    let hamburgerFlag = hamburger.ariaExpanded === 'true' || false;
    hamburger.ariaExpanded = !hamburgerFlag;

    if (navigation.getAttribute('aria-hidden') === 'false') {
      hamburger.classList.remove('is-open');
      lenis.start();
      MicroModal.close('navigation');
      close(); // 追加
    } else {
      header.classList.add('is-open');
      hamburger.classList.add('is-open');
      lenis.stop();
      MicroModal.show('navigation', {
        onClose: () => {
          hamburger.classList.remove('is-open');
          lenis.start();
        },
      });
      open(); // 追加
    }
  }

  //リンククリックでモーダル閉じる処理
  const links = navigation.querySelectorAll('.l-drawer__link');
  if (!links) return;

  links.forEach((link) => {
    link.addEventListener('click', () => {
      if (navigation.getAttribute('aria-hidden') === 'false') {
        hamburger.classList.remove('is-open');
        MicroModal.close('navigation');
      }
    });
  });

  function open() {
    txt.textContent = 'close';
  }
  function close() {
    txt.textContent = 'menu';
  }
}

// ============================================
// header メガメニュー開閉処理
// ============================================
function megaMenu() {
  const links = document.querySelectorAll('.l-navigation__link');
  const targets = document.querySelectorAll('.l-navigation__link.js-popup-trigger');
  const popups = document.querySelectorAll('.l-navigation__child');
  if (links.length === 0 || targets.length === 0 || popups === 0) return;

  MicroModal.init();

  //リンクホバーでポップアップ削除
  const modalList = [];
  links.forEach((link) => {
    const id = link.getAttribute('aria-controls') ?? '';
    if (id) {
      modalList.push(id);
    }
  });
  links.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      modalList.forEach((modalId) => {
        if (document.getElementById(modalId).classList.contains('is-open')) {
          MicroModal.close(modalId);
        }
      });
    });
  });

  //ポップアップからマウス外れるとポップアップ削除
  popups.forEach((popup) => {
    popup.addEventListener('mouseleave', () => {
      const id = popup.id ?? '';
      if (id) {
        MicroModal.close(id);
      }
    });
  });

  //トリガーホバーでポップアップ登場
  targets.forEach((target) => {
    const id = target.getAttribute('aria-controls') ?? '';

    if (id) {
      target.addEventListener('mouseenter', () => {
        if (!document.getElementById(id).classList.contains('is-open')) {
          MicroModal.show(id);
          const modal = document.getElementById(id);
          const link = modal.querySelector('.l-navigation__list-child-link');
          link.blur();
        }
      });
    }
  });
}

export { fixedHeader, drawer, megaMenu };
